import confetti from 'canvas-confetti';

export const CONFETTI_DURATION_MILLISECONDS = 3000;

export const CONFETTI_OPTIONS: confetti.Options = {
  particleCount: 5,
  spread: 55,
  origin: { x: 0.5, y: 0.33 },
  colors: ['#ffd700', '#ffa500', '#ffff00', '#ffe4b5', '#f0e68c'],
  zIndex: 5,
  disableForReducedMotion: true,
};
